import { isGroupAccessId, isStudentAccessId } from "../../../../shared/access-id";

import type { PageGroupUserType, PageType } from "components/server-types";
import type { UserWithSectionActivity } from "store/selectors/types";
import { filterMap } from "utils/collections";
import { rememberDragItem } from "utils/drag-preview";
import { isGroupPage, isIndividualPage } from "utils/page-utils";

export const isValidAccessIdForPageType = (
  page: Pick<PageType, "interaction_mode"> | null,
  accessId: string,
) =>
  page &&
  ((isGroupPage(page) && isGroupAccessId(accessId)) ||
    (isIndividualPage(page) && isStudentAccessId(accessId)));

export const showPageDisabled = (page: Pick<PageType, "released_at" | "category"> | null) =>
  !page?.released_at && page?.category !== "instructor_workspace";

export type DraggableSectionUserType = UserWithSectionActivity & {
  order: number;
  page_group_id?: string;
};

export type DraggablePageGroupUserType = PageGroupUserType & {
  order: number;
};

// Updates page_group_id to the hover target so onDropSectionUser can read the destination.
// Snapshot on first hover so DragAndDrop's endDragPreview restores it if the drag is cancelled —
// otherwise a reused drag item keeps the hover target and a later drop can destroy/mis-move.
export const moveSectionUserLocally = (
  item: DraggableSectionUserType | DraggablePageGroupUserType,
  _toIndex: number,
  dropContainerId: string,
) => {
  rememberDragItem(item, "page_group_id");
  // eslint-disable-next-line no-param-reassign
  item.page_group_id = dropContainerId;
};

export const getUngroupedStudentUsers = (
  readySectionUserIds: readonly string[],
  studentUsers: UserWithSectionActivity[],
): DraggableSectionUserType[] => {
  const readySectionUserIdSet = new Set(readySectionUserIds);

  return filterMap(
    studentUsers,
    (user) => !readySectionUserIdSet.has(user.section_user_id),
    (user, index) => ({ ...user, order: index }),
  );
};
